var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportAssignUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 2,
    fill: "#FFE3C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8997 5.49219C10.6965 5.49219 8.8944 7.29562 8.8944 9.49873C8.8944 10.8458 9.57019 12.0388 10.5976 12.7645C8.20603 13.7233 6.50973 16.0623 6.50973 18.7909C6.49064 19.6511 7.79079 19.6511 7.7717 18.7909C7.7717 15.8947 10.1069 13.5607 13.0032 13.5607C14.0142 13.5607 14.9526 13.8488 15.7514 14.3432C16.4695 14.7836 17.13 13.7065 16.412 13.2661C16.0523 13.0436 15.6626 12.8701 15.2609 12.7201C16.2527 11.9907 16.9012 10.8191 16.9012 9.49873C16.9012 7.29562 15.1028 5.49219 12.8997 5.49219ZM12.8997 6.75541C14.4208 6.75541 15.6393 7.97763 15.6393 9.49873C15.6393 11.0198 14.4208 12.237 12.8997 12.237C11.3786 12.237 10.1564 11.0198 10.1564 9.49873C10.1564 7.97763 11.3786 6.75541 12.8997 6.75541ZM17.8432 18.5646V19.8266C17.8615 20.6494 19.0869 20.6494 19.1052 19.8266V18.5646H20.3684C21.2105 18.5646 21.2105 17.3014 20.3684 17.3014H19.1052V16.0394C19.1093 15.6857 18.8218 15.3976 18.468 15.401C18.1191 15.4034 17.8391 15.6905 17.8432 16.0394V17.3014H16.551C15.6787 17.3417 15.7391 18.6048 16.5812 18.5646H17.8432Z",
    fill: "#DC7700",
    stroke: "#DC7700",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAssignUserIcon);
export default __webpack_public_path__ + "static/media/reportAssignUserIcon.b6f7454cb51dcf0f19494f99ff437cda.svg";
export { ForwardRef as ReactComponent };